enum MODALTYPES {
  NAME = 'NAME',
  DESCRIPTION = 'DESCRIPTION',
  CLIENT_CONTACT = 'CLIENT_CONTACT',
  JRC_CONTACTS = 'JRC_CONTACTS',
  IMAGE = 'IMAGE'
}

export default MODALTYPES;
